/* eslint-disable @typescript-eslint/ban-ts-comment */
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { IBankItem } from "web/types/Banks";

import { ProductSeparatedWithTypes } from "./types";

const getBankMappedWithBalances = (
  banks: IBankItem[],
  productsSeparatedWithTypes: ProductSeparatedWithTypes[]
) =>
  isArrayHasItems(banks)
    ? banks.reduce<Record<string, string>>((result, current) => {
        const bankId = current.points_bank_id;

        const balance = isArrayHasItems(productsSeparatedWithTypes)
          ? productsSeparatedWithTypes.reduce<string>(
              (subResult: string, subCurrent: ProductSeparatedWithTypes) => {
                const { payment_settings: paymentSettings } = subCurrent;
                const currentPayment = paymentSettings.find(
                  (payment) => payment.code === bankId
                );

                return currentPayment
                  ? // @ts-ignore
                    (+(subResult - currentPayment.value).toFixed(2) as string)
                  : subResult;
              },
              current.balance
            )
          : current.balance;

        return {
          ...result,
          [bankId]: balance,
        };
      }, {})
    : {};

export default getBankMappedWithBalances;
